import { styles } from 'util/style'
import css from './Gap.module.scss'

type Props = {
  height?: number
  width?: number
  spring?: boolean
}

export function Gap({ width, height, spring }: Props) {
  const min = width ?? height ?? 0
  const flex = spring ? '1 1 ' + min + 'px' : undefined
  const style = styles({ width, height, flex })

  return <div className={css.gap} style={style} />
}
